module.exports = __webpack_public_path__ + "img/mt4-icon5.cf2de64.png";